import React from 'react';

import { Tooltip } from 'antd';

const DiamondDetailAction = (props) => {
  return (
    <>
      <Tooltip title={props.tooltip} placement={props.placement}>
        <div className="diamondDetailActionItem" onClick={props.onClick}>
          {props.imagenull ? null : <img src={props.image} />}
          {props.title && <span>{props.title}</span>}
        </div>
      </Tooltip>
    </>
  );
};
export default DiamondDetailAction;
